import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [""]
  
  connect() {
    console.log("Rating Hub controller connected")
  }
  
  disconnect() {
    // Cleanup if needed
  }
}

